module.exports = __webpack_public_path__ + "static/media/alerta-documentacion-auto-gris.9200a3a0.svg";